import * as React from "react";
const SvgFiBrandsUnity = (props) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    viewBox="0 0 25 24"
    {...props}
  >
    <path
      fill="#151A2D"
      d="M19.689 14.709v-4.405c0-.195-.157-.3-.313-.195l-4.69 2.597a.43.43 0 0 0-.204.353v5.201c0 .203.157.3.313.203l3.955-2.2 3.861 2.146-10.061 5.576-.023.015-.031-.015-6.809-3.782-3.229-1.801 3.839-2.139 3.963 2.199c.157.098.313-.052.259-.248v-5.208c0-.15-.055-.248-.212-.345l-4.69-2.604c-.102-.053-.313.052-.313.203v4.398L1.45 16.812V5.606L11.613 0v4.3L7.649 6.507c-.156.045-.156.3 0 .345l4.69 2.604c.11.053.266.098.422 0l4.691-2.604c.156-.045.156-.248 0-.345L13.488 4.3V0L23.55 5.606v11.182z"
    />
  </svg>
);
export default SvgFiBrandsUnity;
